import { on as onEvent } from "common/utils/ui/event";
import "./checkout-order-details.scss";
import "components/jiffy/order-line-item/order-line-item";
import "components/jiffy/digital-assets/digital-assets-label/digital-assets-label";
import "components/jiffy/digital-assets/digital-asset-line-item-description/digital-asset-line-item-description";
import "components/jiffy/digital-assets/digital-assets-logo/digital-assets-logo";
import "components/jiffy/digital-assets/digital-assets-download-button/digital-assets-download-button";
import showConfirmation from "components/kit/confirmation_modal/component";

document.addEventListener("DOMContentLoaded", () => {
  onEvent("click", ".js-checkout-order-details-confirm-transition", async (e, $target) => {
    e.preventDefault();

    const { result } = await showConfirmation();

    if (result) {
      window.location.href = $target.href;
    }
  });
});
